import { ArrowRight } from "lucide-react";
import { CHECKOUT_URL } from "@/lib/site";

export const StickyMobileCTA = () => (
  <div data-testid="sticky-mobile-cta" className="fixed bottom-0 inset-x-0 z-50 md:hidden backdrop-blur-xl bg-slate-950/90 border-t border-slate-800 px-4 py-3 shadow-[0_-8px_30px_rgb(0,0,0,0.3)]">
    <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer"
      className="flex items-center justify-center gap-2 rounded-full bg-blue-600 text-white w-full py-3.5 text-base font-bold shadow-[0_8px_20px_0_rgb(37,99,235,0.35)] active:scale-[0.98] transition-transform">
      Start 7-Day Free Trial <ArrowRight size={18} />
    </a>
    <p className="text-center text-[11px] text-slate-500 mt-1.5 font-medium">Free for 7 days · Cancel anytime</p>
  </div>
);
